import { ACTION_CREATE, ACTION_EDIT } from '../../request';
import { Voter } from '../voter';

export class PageBlocksVoter extends Voter {
    /**
     * @param {ACLVoter} acl ACL voter instance
     */
    constructor(acl) {
        super();
        this.acl = acl;
    }

    supports(request) {
        return request.resource === 'page-blocks';
    }

    vote(request) {
        if ((request.includes(ACTION_CREATE) || request.includes(ACTION_EDIT)) && !this.canEdit(request)) {
            return false;
        }
    }

    /**
     * @param {AccessPermissionRequest} request Request in question
     * @returns {boolean} True if request is granted
     */
    canEdit(request) {
        if (!request.subject) {
            return true;
        }

        const kind = request.subject.kind;

        return this.acl.grantsInArrayPayload(request, (kindOrDescriptor) => {
            if (typeof kindOrDescriptor === 'string') {
                return kindOrDescriptor === kind;
            }

            if (kindOrDescriptor.kind !== kind) {
                return false;
            }

            return this.supportsVersion(request, kindOrDescriptor.version);
        });
    }
}
